import useDisableScroll from '@/hooks/useDisableScroll';

import Button from '@/components/ui/Button';
import { WebsiteType } from '@/consts';
import cn from '@/utils/cn';

import { createPortal } from 'react-dom';

interface CaseCardDialogProps {
  title?: string;
  info?: string;
  button?: string;
  secondaryButton?: string;
  onClose?: () => void;
  className?: string;
  variant?: WebsiteType;
}

const Dialog: React.FC<CaseCardDialogProps> = ({
  title,
  info,
  button,
  secondaryButton,
  onClose,
  className,
  variant = WebsiteType.HELPFIND,
}) => {
  useDisableScroll();

  return createPortal(
    <div
      className={
        'fixed left-0 top-0 z-[9999] flex size-full items-center justify-center bg-black/20 backdrop-blur-sm'
      }
    >
      <div className={'absolute size-full blur-sm'} />
      <div
        className={cn(
          'absolute flex size-full items-center justify-center',
          className
        )}
        onClick={onClose}
      >
        <div
          className={cn(
            'z-10 flex max-w-[310px] flex-col gap-y-6 rounded-[28px] bg-white p-6 shadow-[0px_6px_16px_0px_rgba(0,0,0,0.16)] blur-none lg:max-w-[360px] lg:p-9 lg:pt-[42px]'
          )}
          onClick={(e) => e.stopPropagation()}
        >
          <>
            <div className={'flex flex-col items-center gap-y-3 text-center'}>
              <h3
                className={cn(
                  'inline-flex items-center  gap-x-2',
                  variant === WebsiteType.DEEPRY
                    ? 'text-dark-gray-700'
                    : 'text-blue-600'
                )}
              >
                {title}
              </h3>
              {info && (
                <p
                  className="text-dark-gray-500"
                  dangerouslySetInnerHTML={{ __html: info }}
                />
              )}
            </div>
            <div className={cn('flex flex-col gap-y-4')}>
              <div className={'z-20 flex items-center justify-center gap-4'}>
                {button && (
                  <Button
                    size={
                      variant === WebsiteType.DEEPRY ? 'deepDryLarge' : 'large'
                    }
                    intent={
                      variant === WebsiteType.DEEPRY ? 'deepDry' : 'primary'
                    }
                    colors={variant === WebsiteType.DEEPRY ? 'yellow' : 'blue'}
                    className={cn(
                      variant === WebsiteType.DEEPRY
                        ? 'rounded-[24px_8px_24px_8px] font-normal'
                        : ''
                    )}
                    onClick={(e) => {
                      e.stopPropagation();
                      onClose && onClose();
                    }}
                  >
                    {button}
                  </Button>
                )}
              </div>
              {secondaryButton && (
                <div className={'z-20 flex items-center justify-center gap-4'}>
                  <Button
                    size={
                      variant === WebsiteType.DEEPRY ? 'deepDryLarge' : 'small'
                    }
                    intent={'secondary'}
                    className={cn(
                      variant === WebsiteType.DEEPRY
                        ? 'text-dark-gray-700'
                        : '',
                      variant === WebsiteType.DEEPRY
                        ? 'rounded-[24px_8px_24px_8px] font-normal'
                        : ''
                    )}
                    onClick={(e) => {
                      e.stopPropagation();
                      onClose && onClose();
                    }}
                  >
                    {secondaryButton}
                  </Button>
                </div>
              )}
            </div>
          </>
        </div>
      </div>
    </div>,
    document.body
  );
};
export default Dialog;
